import React, { useEffect, useState } from "react";
import Label from "../Label/Label";
import "./TextFiled.scss";

export type input = "input" | "textarea";
export type type =
  | "text"
  | "radio"
  | "checkbox"
  | "color"
  | "file"
  | "date"
  | "time"
  | "datetime-local"
  | "submit"
  | "button"
  | "email"
  | "hidden"
  | "image"
  | "number"
  | "password"
  | "range"
  | "search"
  | "url";

export interface Props {
  TextFieldClass?: string;
  TextFieldId?: string;
  Type: input;
  value?: string | number;
  name?: string;
  PlaceHolder?: string;
  LabelName?: string;
  SubType?: type;
  onClick?: () => void;
  onBlur?: () => void;
  onFocus?: () => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  defaultValue?: string;
  OnkeyDown?: (event: React.KeyboardEvent) => void;
  OnkeyUp?: (event: React.KeyboardEvent) => void;
  readOnly?: boolean;
  Disabled?: boolean;
  contentEditable?: boolean;
  spellCheck?: boolean;
  required?: boolean;
  mainStyle?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
}

function TextField({
  TextFieldClass,
  TextFieldId,
  Type: Element = "input",
  value,
  name,
  PlaceHolder,
  LabelName,
  SubType = "text",
  onClick,
  onBlur,
  onFocus,
  onChange,
  defaultValue,
  OnkeyDown,
  OnkeyUp,
  readOnly,
  Disabled,
  contentEditable = false,
  spellCheck = false,
  required = false,
  mainStyle,
  labelStyle,
  inputStyle,
}: Props) {
  const [typeCheck, setTypeCheck] = useState<boolean>(false);

  useEffect(() => {
    if (SubType === "checkbox" || SubType === "radio") {
      setTypeCheck(true);
    } else {
      setTypeCheck(false);}
  }, [SubType]);
  return (
    <>
      {typeCheck === false && (
        <div className="mfg-textField" style={mainStyle && mainStyle}>
          {LabelName && <Label style={labelStyle && labelStyle} Labelfor={TextFieldId}>{LabelName}</Label>}
          <Element
            onKeyDown={OnkeyDown}
            onKeyUp={OnkeyUp}
            defaultValue={defaultValue}
            onClick={onClick}
            onBlur={onBlur}
            onFocus={onFocus}
            type={SubType}
            className={TextFieldClass ? `${TextFieldClass} ` : ""}
            id={TextFieldId}
            name={name}
            value={value}
            placeholder={PlaceHolder}
            onChange={onChange}
            readOnly={readOnly}
            disabled={Disabled}
            contentEditable={contentEditable}
            spellCheck={spellCheck}
            required={required}
            style={inputStyle && inputStyle}
          />
        </div>
      )}
      {typeCheck === true && (
       <div className="mfg-textField">
          <Element
            onKeyDown={OnkeyDown}
            onKeyUp={OnkeyUp}
            defaultValue={defaultValue}
            onClick={onClick}
            onBlur={onBlur}
            onFocus={onFocus}
            type={SubType}
            className={`${TextFieldClass ? TextFieldClass + " " : ""}${
              typeCheck ? "mfgPosition" : ""
            }`}
            id={TextFieldId}
            name={name}
            value={value}
            placeholder={PlaceHolder}
            onChange={onChange}
            readOnly={readOnly}
            disabled={Disabled}
            required={required}
            style={inputStyle && inputStyle}
          />
          {typeCheck && (
            <Label
              Labelfor={TextFieldId}
              LabelClass={`selectionType${SubType === "radio" ? " radio" : ""}`}
              style={labelStyle && labelStyle}
            >
              {LabelName}
            </Label>
          )}
        </div>
      )}
    </>
  );
}

export default TextField;
